import { render, staticRenderFns } from "./SendShipment.vue?vue&type=template&id=7bdceca7&"
import script from "./SendShipment.vue?vue&type=script&lang=js&"
export * from "./SendShipment.vue?vue&type=script&lang=js&"
import style0 from "./SendShipment.vue?vue&type=style&index=0&id=7bdceca7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports